"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTagsPaginated = exports.getTags = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
const options_1 = require("./options");
/**
 * Fetches a list of tags for a repository using link-header pagination.
 *
 * Retrieves all available tags for a specific repository using the standard link-header
 * pagination mechanism. This is the traditional pagination approach supported by most registries.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/tags/list`
 *
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param pageSize - Number of tags to fetch per request (default: 1000)
 * @param maxPages - Maximum number of pages to fetch (default: Number.MAX_SAFE_INTEGER)
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns Array of tag names in the repository
 */
async function getTags(registryBase, repo, username, password, pageSize = 1000, maxPages = Number.MAX_SAFE_INTEGER, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const endpoint = `/${repo}/tags/list`;
    return await (0, registry_call_1.paginatedV2Call)(registryBase, contentTypes.JSON, username, password, endpoint, "tags", pageSize, maxPages, cloned, observer);
}
exports.getTags = getTags;
/**
 * Fetches a list of tags using Docker Registry v2 API "last marker" pagination.
 *
 * This function uses the "last" marker approach for pagination, which correctly implements
 * the Docker Registry V2 pagination pattern. This allows for unbounded retrieval of tags
 * without the traditional link header limitations. This approach is more robust and
 * recommended for registries with large numbers of tags.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/tags/list`
 *
 * @param registryBase - The base URL of the container registry
 * @param repo - The repository name (e.g., "library/nginx")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param pageSize - Number of tags to fetch per request (default: 1000)
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns Complete array of all tag names in the repository
 *
 * @see https://distribution.github.io/distribution/spec/api/#pagination-1
 */
async function getTagsPaginated(registryBase, repo, username, password, pageSize = 1000, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const endpoint = `/${repo}/tags/list`;
    return await (0, registry_call_1.paginatedV2CallWithLastMarker)(registryBase, contentTypes.JSON, username, password, endpoint, "tags", pageSize, cloned, observer);
}
exports.getTagsPaginated = getTagsPaginated;
//# sourceMappingURL=get-tags.js.map